import axios from 'axios';

let prefix = "/kiosk"

const KioskApi = {
	
	getKioskList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getKioskInfo(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createKiosk(payload){
		return axios.post( prefix + "/create", payload)
	},
	deleteKiosk(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
	updateKiosk(payload){
		return axios.post( prefix + "/update", payload)
	},
	toggleKioskActive(payload){
		return axios.post( prefix + "/toggle-active", payload)
	},

}

export default KioskApi;